module.exports = __webpack_public_path__ + "static/media/4 Underhook.967750d5.jpg";